import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './EasyPost.frontend.types'

@Injectable({ providedIn: 'root' })
export class EasyPost_retrieve_tracker_status_request_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { easyPostTrackerId: string }): Promise<{ status?: string, outputDetails?: string }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.easyPostTrackerId)) {
      missingRequiredInParams.push('\'easyPostTrackerId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/EasyPost/functions/retrieve_tracker_status_request_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

